(function () {
    angular.module('components.paginationOld', [
        'services.global',
        'components.sort'
    ])
        .controller('BmgPaginationController', bmgPaginationController)
        .directive('bmgPagination', bmgPagination)
        .directive('bmgPaginationModal', bmgPaginationModal)
        .directive('bmgPaginationPageLinks', bmgPaginationPageLinks)
        .directive('bmgPaginationTrigger', bmgPaginationTrigger)
        .directive('bmgPaginationFilter', bmgPaginationFilter)
        .directive('bmgPaginationParam', bmgPaginationParam)
        .directive('bmgPaginationEmpty', bmgPaginationEmpty)
        .directive('bmgPaginationFinished', bmgPaginationFinished);
    bmgPaginationTrigger.$inject = ['$animate'];
    bmgPaginationEmpty.$inject = ['$animate'];
    bmgPaginationFinished.$inject = ['$animate'];

    bmgPaginationController.$inject = ['$scope', '$injector', '$timeout', '$q', '$stateParams', 'FoundationApi'];
    function bmgPaginationController($scope, $injector, $timeout, $q, $stateParams, foundationApi) {
        var controller = this;
        var infinite = $scope.infinite = controller.infinite = $scope.infinite === 'false' ? false : true;
        var currentPage = controller.currentPage = $scope.currentPage = $scope.page || 0;
        var startPage = currentPage;
        var take = controller.take = $scope.take = $scope.take || 15;
        var service, method;
        var items = controller.items = $scope.items = [];
        var container = controller.container = angular.element($scope.container || '#content > .grid-content:first-child');
        var filters = {};
        var previousData;
        var delay;
        var initLoad = true;
        controller.empty = $scope.empty = false;
        controller.toPage = function (page, refresh, callback) {
            function processData(data) {
                if (infinite && !reset && !refresh) {
                    for (var i = 0; i < data.items.length; i++)
                        items.push(data.items[i]);
                }
                else
                    items = controller.items = $scope.items = data.items;
                controller.rows = $scope.rows = data.totalCount || data.rows;
                controller.pageLimit = $scope.pageLimit = Math.ceil(data.rows / take);
                $scope.finished = items.length === data.totalCount || items.length === data.rows;
                controller.empty = $scope.empty = items.length === 0;
                reset = false;
                if (callback !== undefined) {
                    callback(data);
                }
            }
            var newPage = currentPage;
            switch (page) {
                case 'prev':
                    newPage--;
                    break;
                case 'next':
                    newPage++;
                    break;
                default:
                    newPage = page;
                    break;
            }
            if (newPage > -1) {
                if (service) {
                    $timeout.cancel(delay);
                    delay = $timeout(function () {
                        currentPage = newPage;
                        var params = {
                            pageSize: take,
                            offset: currentPage * take
                        };
                        var preventExecution = false;
                        for (var key in $scope.additionalParams) {
                            if ($scope.additionalParams[key] === null) {
                                preventExecution = true;
                                break;
                            }
                            params[key] = $scope.additionalParams[key];
                        }
                        for (var key in filters) {
                            if (!filters[key])
                                delete params[key];
                            else
                                params[key] = filters[key];
                        }
                        if ((!preventExecution && !angular.equals(params, previousData)) || refresh) {
                            $scope.currentPage = page;
                            initLoad = false;
                            previousData = params;
                            controller.paginationPromise = $scope.paginationPromise = service[method].get(params, processData);
                        }
                    });
                }
                else if ($scope.data !== undefined) {
                    var offset = currentPage * take;
                    processData({
                        ctrl: controller,
                        items: angular.copy($scope.data.slice(offset, offset + take)),
                        rows: $scope.data.length
                    });
                }
            }
        };
        controller.nextPage = function (callback) {
            controller.toPage(currentPage + 1, false, callback);
        },
        controller.prevPage = function (callback) {
            controller.toPage(currentPage - 1, false, callback);
        }

        controller.hasMore = function () {
            return !$scope.finished;
        }

        controller.refresh = function () {
            controller.toPage(0, true);
        }

        controller.updateFilter = function (filterName, data) {
            filters[filterName] = data;
            reset = true;
            controller.toPage(0);
        }

        controller.reset = function () {
            filters = {};
            items = controller.items = $scope.items = [];
            controller.toPage(0);
        }

        controller.registerTrigger = function () {
            $scope.hasControls = true;
        }

        controller.switchService = function (serv) {
            if (serv !== service) {
                if (serv) {
                    var servicePieces = serv.split('.');
                    if (servicePieces.length !== 2)
                        console.log('"' + service + '" is not a valid service');
                    else {
                        service = controller.service = $injector.get(servicePieces[0]);
                        method = controller.method = servicePieces[1];
                        controller.toPage(startPage);
                    }
                }
                else
                    console.log('Service is not defined');
            }
        }

        controller.pushToFront = function (item) {
            $scope.items.unshift(item);
        }

        //loads the initial set of data
        controller.switchService($scope.service);
        var reset = false;
        $scope.$watch('additionalParams', function (newVal) {
            reset = true;
            controller.toPage(initLoad && $stateParams.page !== undefined ? $stateParams.page - 1 : 0);
        }, true);

        // activity helper methods      
        $scope.getItemTypeString = function (activity) {
            switch (activity.Item.Type) {
                case 0: return 'Idea';
                case 1: return 'Researach';
                case 2: return 'Innovation';
                case 3: return 'Feedback';
            }
        };

        $scope.getActionTypeString = function (activity) {
            switch (activity.ActionType) {
                case 0: return 'Added';
                case 1: return 'Submitted';
                case 2: return 'Created';
                case 3: return 'Updated';
            }
        };

        $scope.getHeader = function (activity) {
            return $scope.getItemTypeString(activity) + ' ' + $scope.getActionTypeString(activity);
        };

        $scope.$root.$on('refreshPagination', controller.refresh);
    }

    bmgPagination.$inject = ['$timeout', '$window', '$transitions'];
    function bmgPagination($timeout, $window, $transitions) {
        var nextId = 0;
        var directive = {
            scope: {
                take: '@?',
                service: '@?',
                page: '@?',
                container: '@?',
                infinite: '@?',
                additionalParams: '=?',
                data: '=?',
                onChange: '&?'
            },
            restrict: 'EA',
            transclude: true,
            replace: true,
            templateUrl: '/angular/components/pagination/pagination.html',
            controller: 'BmgPaginationController',
            link: link
        };
        return directive;
        function link(scope, element, attrs, controller, transclude) {
            if (attrs.state !== undefined) {
                controller.state = scope.state = attrs.state;
                $transitions.onEnter({
                    to: attrs.state
                }, function ($transition$) {
                    controller.toPage($transition$.params().page - 1, true);
                })
            }
            var id = nextId++;
            var itemContainer;
            var checkPoint;
            var window = angular.element($window);
            function updateCheckPoint() {
                checkPoint = window.height() * 1.5;
            }
            window.off('resize.pagination').on('resize.pagination', updateCheckPoint)
            updateCheckPoint();
            transclude(scope, function (clone, scope) {
                if (clone.length) {
                    element.append(clone);
                }
            });
            scope.$emit('paginationReady');
            function loadCheck(event) {
                if (((scope.paginationPromise !== undefined && scope.paginationPromise.$resolved) || scope.data !== undefined) && itemContainer) {
                    var bottom = itemContainer.getBoundingClientRect().bottom;
                    if (bottom < checkPoint)
                        controller.nextPage();
                }
            }

            var watchingScroll = false;
            scope.$watch('hasControls', function (hasControls) {
                if (hasControls)
                    controller.container.off('scroll.paginate' + id);
                else {
                    controller.container.on('scroll.paginate' + id, loadCheck);
                    watchingScroll = true;
                    scope.$on('$destroy', function () {
                        controller.container.off('scroll.paginate' + id);
                    });
                    scope.$watch('items', function (items) {
                        if (items !== undefined && items.length > 0 && itemContainer === undefined) {
                            $timeout(function () {
                                itemContainer = element.find('[ng-repeat*="in items"]:eq(0)').parent()[0];
                            }, 0);
                        }
                        if (scope.onChange !== undefined) {
                            scope.onChange({
                                items: items,
                                rows: controller.rows
                            });
                        }
                        scope.itemsBinding = items;
                    });
                    scope.$watch('finished', function (finished) {
                        if (finished)
                            controller.container.off('scroll.paginate' + id);
                        else
                            controller.container.on('scroll.paginate' + id, loadCheck);
                    });
                }
            });
        }
    }

    bmgPaginationPageLinks.$inject = [];
    function bmgPaginationPageLinks() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/angular/components/pagination/pagination-page-links.html',
            require: '^bmgPagination',
            link: link
        }
        return directive;

        function link(scope, element, attrs, controller) {
            controller.registerTrigger();
        }
    }

    bmgPaginationModal.$inject = ['$window', '$templateRequest', '$compile'];
    function bmgPaginationModal($window, $templateRequest, $compile) {
        var nextId = 0;
        var directive = {
            scope: {
                initialLimit: '=?',
                take: '@?',
                service: '@?',
                page: '@?',
                params: '=?'
            },
            restrict: 'EA',
            transclude: {
                emptyMessage: '?emptyMessage',
                finishedMessage: '?finishedMessage',
                banner: '?banner',
                entry: '?entry'
            },
            replace: true,
            template: '<div class="pagination-modal"></div>',
            link: link
        };
        return directive;
        function link(scope, element, attrs, controller, transclude) {
            var id = nextId++;
            var itemContainer;
            var window = angular.element($window);
            var scroller;
            if (scope.initialLimit === undefined)
                scope.initialLimit = 5;
            $templateRequest('/angular/components/pagination/pagination-modal.html', true).then(function (markup) {
                if (scope.$$destroyed) return;
                var paginator = angular.element(markup);
                transclude(scope, function (clone) {
                    if (clone.length)
                        paginator.find('[ng-repeat]').html(clone);
                }, null, 'entry');
                transclude(scope, function (clone) {
                    if (clone.length)
                        paginator.find('.banner').html(clone);
                }, null, 'banner');
                transclude(function (clone) {
                    if (clone.length)
                        paginator.find('.empty').html(clone);
                }, null, 'emptyMessage');
                transclude(function (clone) {
                    if (clone.length)
                        paginator.find('.finished').html(clone);
                }, null, 'finishedMessage');
                if (attrs.take !== undefined)
                    paginator.attr('take', attrs.take);
                var modalId = 'pagination-modal-' + id;
                paginator.attr({
                    service: attrs.service,
                    container: '#' + modalId + ' .pagination-container'
                });
                paginator.find('[zf-open]').attr('zf-open', modalId);
                paginator.find('zf-modal').attr('id', modalId);
                element.append(paginator);
                $compile(element.contents())(scope);
            });
        }
    }

    function bmgPaginationTrigger($animate) {
        var directive = {
            restrict: 'A',
            scope: {
                page: '@',
                trigger: '@?'
            },
            require: '^bmgPagination',
            controller: function () { },
            link: link
        }
        return directive;
        function link(scope, element, attrs, controller) {
            controller.registerTrigger();
            if (scope.trigger === undefined)
                scope.trigger = 'click';
            element.on(scope.trigger, function () {
                controller.toPage(scope.page);
                return false;
            });
            scope.$parent.$watch('finished', function (newVal) {
                if (newVal)
                    $animate.addClass(element, 'ng-hide');
                else
                    $animate.removeClass(element, 'ng-hide');
            });
        }
    }

    function bmgPaginationFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                data: '=',
                name: '@',
                property: '@?',
                disableDataChanges: '=?'
            },
            transclude: true,
            replace: true,
            template: '<div class="filter"></div>',
            require: '^bmgPagination',
            link: link
        };

        return directive;

        function link(scope, element, attrs, controller, transclude) {
            if (scope.property === undefined)
                scope.property = 'value';
            if (!scope.disableDataChanges) {
                scope.$watch('data', function (newVal) {
                    if (newVal !== undefined) {
                        var actives = [];
                        for (var key in newVal) {
                            if (newVal[key].active)
                                actives.push(newVal[key][scope.property])
                        }
                        if (actives.length === 0)
                            actives = undefined;
                        controller.updateFilter(scope.name, actives);
                    }
                }, true);
            }
            scope.$watch(scope.name, function (newVal, preVal) {
                if (newVal !== preVal)
                    controller.updateFilter(scope.name, newVal);
            });
            transclude(scope, function (clone, scope) {
                element.append(clone);
            });
        }
    }

    function bmgPaginationParam() {
        var directive = {
            restrict: 'A',
            require: ['^bmgPagination', 'ngModel'],
            link: link
        };

        return directive;

        function link(scope, element, attrs, controllers) {
            var paginator = controllers[0];
            var ngModel = controllers[1];
            var pieces = attrs.ngModel.split('.');
            var name = pieces[pieces.length - 1];
            scope.$watch('data', function (newVal) {
                if (newVal !== undefined) {
                    var actives = [];
                    for (var key in newVal) {
                        if (newVal[key].active)
                            actives.push(newVal[key].value)
                    }
                    if (actives.length === 0)
                        actives = undefined;
                    paginator.updateFilter(scope.name, actives);
                }
            }, true);
            ngModel.$viewChangeListeners.push(function () {
                paginator.updateFilter(name, ngModel.$modelValue);
            });
        }
    }

    function bmgPaginationServiceSwitcher() {
        var directive = {
            restrict: 'E',
            replace: true,
            scope: {
                services: '='
            },
            require: '^bmgPagination',
            template: '<select ng-model="service"><option ng-repeat="item in ::services">{{::item}}</option></select>',
            link: link
        };
        return directive;
        function link(scope, element, attrs, controller) {
            scope.service = controller.service;
            scope.$watch('service', function (newVal) {

            })
        }
    }

    function bmgPaginationEmpty($animate) {
        var directive = {
            restrict: 'E',
            scope: {
                page: '@',
                trigger: '@?'
            },
            transclude: true,
            replace: true,
            template: '<div class="empty" ng-transclude></div>',
            require: '^bmgPagination',
            link: link
        }
        return directive;
        function link(scope, element, attrs, controller) {
            scope.$parent.$watch('items', function (newVal) {
                if (newVal && controller.empty)
                    $animate.removeClass(element, 'ng-hide');
                else
                    $animate.addClass(element, 'ng-hide');
            })
        }
    }

    function bmgPaginationFinished($animate) {
        var directive = {
            restrict: 'E',
            transclude: true,
            replace: true,
            template: '<div class="finished" ng-transclude></div>',
            require: '^bmgPagination',
            link: link
        }
        return directive;
        function link(scope, element, attrs, controller) {
            scope.$watch('finished', function (newVal) {
                if (newVal && !controller.empty)
                    $animate.removeClass(element, 'ng-hide');
                else
                    $animate.addClass(element, 'ng-hide');
            })
        }
    }
})();